/**
 * Run each field's validator function
 *
 * Used in Svelte forms, reactive assignment on every update to show errors right away if not valid
 *
 * @param {Object[]} fields - fields to validate
 */
function validateFields(fields) {
  fields.forEach(field => {
    field.touched = field.touched === true ? true : field.value.length > 0;
    field.error = !field.validator(field.value);
  });
}

export default validateFields;



// WEBPACK FOOTER //
// ./scripts/util/validation/validateFields.js